import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#0E0E0E',
      paper: '#252525',
    },
    text: {
      primary: '#F1F1F1',
      secondary: '#D9D9D9',
      disabled: '#727F9C',
    },
    primary: {
      main: '#FF6141',
      contrastText: '#F1F1F1',
    },
    secondary: {
      main: '#46A4EC',
      contrastText: '#F1F1F1',
    },
    error: {
      main: '#F44336',
      contrastText: '#FFFFFF',
    },
    action: {
      active: '#FFFFFF',
      hover: 'rgba(255, 255, 255, 0.08)',
      selected: 'rgba(255, 97, 65, 0.2)',
      disabled: 'rgba(255, 255, 255, 0.3)',
      disabledBackground: 'rgba(255, 255, 255, 0.12)',
      disabledOpacity: 1,
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h4: {
      fontWeight: 500,
      color: '#F1F1F1',
    },
    body1: {
      color: '#D9D9D9',
    },
    button: {
      fontWeight: 500,
      fontSize: '1rem',
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '10px 20px',
          fontSize: '1rem',
          minWidth: '100px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
          '&.Mui-disabled': {
            color: '#727F9C',
          },
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
          '&.Mui-disabled': {
            color: 'rgba(255, 255, 255, 0.3)',
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
          },
        },
        containedPrimary: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        containedSecondary: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        outlined: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        text: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
      defaultProps: {
        size: 'medium',
        variant: 'contained',
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          paddingRight: '24px',
          paddingBottom: '16px',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1C1C1C',
          color: '#F1F1F1',
          borderRight: '1px solid rgba(255, 255, 255, 0.12)',
          width: 240,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(255, 97, 65, 0.2)',
            color: '#FF6141',
            '& .MuiTypography-root': {
              fontWeight: 700,
            },
          },
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
          },
          padding: '12px 16px',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: '1.1rem',
          fontWeight: 500,
          color: '#F1F1F1',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          backgroundColor: '#252525',
        },
      },
    },
  },
});
